define('viewmodels/ProductRiskRating/ProductConfiguration',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils) {
        var app = require('durandal/app'),
            ko = require('knockout');

        var ProductConfigurationVM = {
            logger: logger,
            attached: attached,
            appsecurity: appsecurity,
            currentPageNumber: ko.observable(),
            //Attributes
            openAttributePopup: openAttributePopup,
            currentAttributesPageNumber: ko.observable(),
            attributes: ko.observableArray([]),
            getAttributes: getAttributes,
            selectedAttribute: ko.observable(new ProductAttributeModel({})),
            submitAttributes: submitAttributes,
            isEditingAttribute: ko.observable(true),
            deleteAttrbuteButtonClick: deleteAttrbuteButtonClick,
            deleteAttribute: deleteAttribute,
            cancelAttributes: cancelAttributes,
            // Products 
            openProductPopup: openProductPopup,
            products: ko.observableArray([]),
            selectedProduct: ko.observable(new ProductModel({})),
            getProducts: getProducts,
            deleteProductButtonClick: deleteProductButtonClick,
            deleteProductButtonClickBulk: deleteProductButtonClickBulk,

            productName: ko.observable(),
            productDescription: ko.observable(),
            productStatus: ko.observable(),
            addProduct: addProduct,
            deleteProduct: deleteProduct,
            SelectAllProducts: SelectAllProducts,
            DisableActionButtons: ko.observable(false),
            SelectedProductList: ko.observableArray([]),
            //Users
            openAssingUserPopup: openAssingUserPopup,
            SelectAllUsers: SelectAllUsers,
            UserList: ko.observableArray([]),
            GetALLRespondents: GetALLRespondents,
            AssingUsers: AssingUsers,
            AssignUsersBulk: AssignUsersBulk,
            toggleSelect: toggleSelect,
            selectedUsers: ko.observableArray([]),
            productID: ko.observable(),
            getAssignedNamesByID: getAssignedNamesByID,
            isBulk: ko.observable(false),
            // Launch Status
            OpenlaunchProductPopup: OpenlaunchProductPopup,
            CloseLaunchProductPopup: CloseLaunchProductPopup,
            LaunchProduct: LaunchProduct,
            LaunchProductList: ko.observableArray([]),
            SelectedProductListID: ko.observableArray([]),
            //singleLaunchForProduct: singleLaunchForProduct
        };

        return ProductConfigurationVM;

        var ProductsTableObj = false;
        var AttributesTableObj = false;
        var TableObject;

        function attached() {
            GetALLRespondents();
            AttributesTableObj = $('#attributesTable').DataTable({ "bVisible": false });
            $('#attributesTable').on('page.dt', function (event) {
                ProductConfigurationVM.currentAttributesPageNumber(AttributesTableObj.page());
            });

            ProductsTableObj = $('#productsTable').DataTable({ "bVisible": false });
            $('#productsTable').on('page.dt', function (event) {
                ProductConfigurationVM.currentPageNumber(ProductsTableObj.page());
            });

            getAttributes();
        }
        //Users 
        function getAssignedNamesByID(assignedUsersData) {
            var assignedUserList = ko.toJS(assignedUsersData).split(',')

            var userNames = "";
            for (var i = 0; i <= assignedUserList.length; i++) {
                for (var k = 0; k <= ProductConfigurationVM.UserList().length; k++) {
                    if (assignedUserList[i] && ProductConfigurationVM.UserList()[k]) {
                        if (ProductConfigurationVM.UserList()[k].UserId() == assignedUserList[i]) {
                            if (i == 0)
                                userNames += ProductConfigurationVM.UserList()[k].UserName().split('(', 1);
                            else
                                userNames += " | " + ProductConfigurationVM.UserList()[k].UserName().split('(', 1);;
                        }
                    }
                }
            }

            return userNames || 'Unassigned';
        }

        function openAssingUserPopup(data) {
            ProductConfigurationVM.productID(ko.toJS(data.ID));
            var rows = $("#MappingTable").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true) {
                    $(rows[i]).find("td:eq(1)").find('input').prop("checked", true);
                    ProductConfigurationVM.UserList()[i].IsChecked(event.currentTarget.checked);
                }
                else {
                    $(rows[i]).find("td:eq(1)").find('input').prop("checked", false);
                    ProductConfigurationVM.UserList()[i].IsChecked(event.currentTarget.checked);
                }
            }
        }

        function toggleSelect(data) {

        }


        function GetALLRespondents(RoleType) {
            try {
                return $.ajax({
                    url: "/api/Survey/GetALLSurveyUsers",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, Success) {
                        ProductConfigurationVM.UserList([]);
                        var MappedList = $.map(jsonResult, function (result) {
                            if (result.RoleType === 'PRA_RESP') {
                                return new RespondentListModel(result);
                            }
                        });
                        //SCViewModel.SurveyUsersList(MappedList);
                        //$('#MappingTable').DataTable();
                        ProductConfigurationVM.UserList(MappedList)
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ProductConfigurationVM), true);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetALLRespondents() method in CreateSurvey.js';
                logger.logMessage(msg);
            }
        }

        function SelectAllUsers() {
            try {
                var rows = $("#MappingTable").dataTable().fnGetNodes();
                var cells = [];
                for (var i = 0; i < rows.length; i++) {
                    if (event.currentTarget.checked == true) {
                        $(rows[i]).find("td:eq(1)").find('input').prop("checked", true);
                        ProductConfigurationVM.UserList()[i].IsChecked(event.currentTarget.checked);
                    }
                    else {
                        $(rows[i]).find("td:eq(1)").find('input').prop("checked", false);
                        ProductConfigurationVM.UserList()[i].IsChecked(event.currentTarget.checked);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SelectAllUsers() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function SelectAllProducts(data, event) {
            try {
                if (event.currentTarget.checked) {
                    for (var i = 0; i < ProductConfigurationVM.products().length; i++) {
                        ProductConfigurationVM.products()[i].IsChecked(event.currentTarget.checked);
                    }
                }
                else {
                    for (var i = 0; i < ProductConfigurationVM.products().length; i++) {
                        ProductConfigurationVM.products()[i].IsChecked(event.currentTarget.checked);
                    }
                }
                var rows = $("#productsTable").dataTable().fnGetNodes();
                var cells = [];
                for (var i = 0; i < rows.length; i++) {
                    if (event.currentTarget.checked == true)
                        $(rows[i]).find("td:eq(1)").find('input').prop("checked", true);
                    else
                        $(rows[i]).find("td:eq(1)").find('input').prop("checked", false);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SelectAllProducts() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function AssingUsers() {
            try {
                var users = ko.toJS(ProductConfigurationVM.UserList());


                var mappedUserList = $.map(users, function (result) {
                    if (result.IsChecked === true) {
                        return result.UserId
                    }
                });

                var userID = mappedUserList.toString();
                if (ProductConfigurationVM.isBulk() === true) {
                    var productID = ProductConfigurationVM.SelectedProductList().join(',');
                } else {
                    var productID = ProductConfigurationVM.productID();
                }

                return $.ajax({
                    url: "/api/productConfiguration/products/assignUser?productID=" + productID + "&userID=" + userID,
                    type: "PUT",
                    headers: appsecurity.getSecurityHeaders()
                }).success(AjaxSuccess).fail(AjaxFail);

                function AjaxSuccess(jsonResult, Success) {
                    $("#assignUserPopUp").modal('hide');
                    getProducts();
                    ProductConfigurationVM.isBulk(false);

                }
                function AjaxFail() {

                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:SaveUserMapping() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function AssignUsersBulk(data) {
            try {
                ProductConfigurationVM.isBulk(true);
                ProductConfigurationVM.DisableActionButtons(false);
                ProductConfigurationVM.SelectedProductList([]);
              
                for (var i = 0; i < ProductConfigurationVM.products().length; i++) {
                    if (ProductConfigurationVM.products()[i].IsChecked()) {
                        ProductConfigurationVM.SelectedProductList().push(ProductConfigurationVM.products()[i].ID);
                    }
                }
                $('#assignUserPopUp').modal('show');
                $('#selectallUsers').prop('checked', false);

                if (ProductConfigurationVM.SelectedProductList().length == 0) {
                    $('#assign-user-errors').show();
                    $("#PopupBody").hide();
                    $('#assign-user-errors').html('None of the Products have been selected to perform the group actions');
                    ProductConfigurationVM.DisableActionButtons(true);
                }
                else {
                    $('#assign-user-errors').hide();
                    $("#PopupBody").show();
                    //var object = $('#MappingTable').DataTable();

                    object.destroy();
                    $("#MappingTable tbody tr").remove();

                    //GetALLRespondents()
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:AssignBulkResponders() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        //End of Users

        // Launch Status Methods
        function OpenlaunchProductPopup() {
            try {
                $("#frmlaunchPopup").modal('show');
                ProductConfigurationVM.SelectedProductListID([]);
                ProductConfigurationVM.DisableActionButtons(false);
                var arr = [];

                for (var i = 0; i < ProductConfigurationVM.products().length; i++) {
                    if (ProductConfigurationVM.products()[i].IsChecked()) {
                        ProductConfigurationVM.SelectedProductListID().push(ProductConfigurationVM.products()[i].ID);

                    }
                    else {
                        arr.push(ProductConfigurationVM.products()[i].ID);
                    }
                }

                if (ProductConfigurationVM.SelectedProductListID().length == 0) {
                    $('#ValErrorLaunch').show();
                    $("#LaunchPopupBody").hide();
                    $('#ValErrorLaunch').html('None of the Products have been selected to perform the group actions');
                    ProductConfigurationVM.DisableActionButtons(true);
                }
                else {
                    $('#ValErrorLaunch').hide();
                    $("#LaunchPopupBody").show();
                    ProductConfigurationVM.LaunchProductList([]);
                    var TableObject = $("#ProductLaunchTable").DataTable();
                    if (TableObject != undefined) {
                        TableObject.destroy();
                        $("#ProductLaunchTable tbody tr").remove();
                    }
                    else {
                        TableObject = $("#ProductLaunchTable").DataTable();
                        $("#ProductLaunchTable tbody tr").remove();
                        TableObject.destroy();
                    }
                    var mappedLaunchProductgroup = $.map(ProductConfigurationVM.products(), function (result) {
                        //var ProductObj = new LaunchProductModel(result);
                        //return ProductObj;
                        return result;
                    });
                    ProductConfigurationVM.LaunchProductList(mappedLaunchProductgroup);
                    for (var i = 0; i < arr.length; i++) {
                        ProductConfigurationVM.LaunchProductList.remove(function (item) { return item.ID == arr[i] })
                    }
                    
                    var TableObject = $("#ProductLaunchTable").DataTable(); 
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in OpenlaunchProductPopup() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function CloseLaunchProductPopup() {
            try {
                ProductConfigurationVM.SelectedProductListID([]);
                $("#frmlaunchPopup").modal('hide');

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in CloseLaunchProductPopup() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //function singleLaunchForProduct(data) {
        //  var selectedProduct = ProductConfigurationVM.SelectedProductListID().push(data.ID)
        //    app.showMessage('<b>Are you sure that you want to Launch this Product?<br/><br/><b>', 'Launch Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
        //    .then(function (option) {
        //        if (option === 'Confirm') {
        //            LaunchProduct(selectedProduct);
        //            toastr.success("Products has been launched successfully");
        //        }
        //    });
        //}

        function LaunchProduct(data) {
            if (data.ID) {
                var productID = data.ID;
            } else {
                var productID = ProductConfigurationVM.SelectedProductListID().join();
            }
            try {
                app.showMessage('<b>Are you sure that you want to Launch this Product?<br/><br/><b>', 'Launch Request', [' Confirm', 'Cancel'], true, { primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-rocket' })
                    .then(function (option) {
                        if (option === ' Confirm') {



                            //            var BuIdList = ConstructLaunchSurveyJson();
                            //            if (BuIdList.length == 0) {
                            //                logger.logError('The selected surveys have already been launched or questionnaire haven\'t been assigned.', 'Error', system.getModuleId(SCViewModel), true);
                            //            }
                            //            else {
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            return $.ajax({
                                url: "/api/productConfiguration/products/setLaunchStatus?launchedProducts=" + productID,
                                headers: headers,
                                type: "PUT",
                            })
                                .success(function (jsonResult, success) {
                                    getProducts();
                                    ProductConfigurationVM.SelectedProductListID([]);
                                    ProductConfigurationVM.LaunchProductList([]);
                                    $("#frmlaunchPopup").modal('hide');
                                    toastr.success("Products has been launched successfully");
                                })
                                .fail(function (jsonResult, error) {

                                })
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LaunchSurvey() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function openAttributePopup(data) {
            $('#valErrorRA').hide();
            $('#valErrorRA').text('');
            if(!data)
                getAttributes();
            ProductConfigurationVM.selectedAttribute(new ProductAttributeModel({}));

            if (data) {
                ProductConfigurationVM.selectedAttribute(data);
            }
        }

        /**
         * Get All Attributes and set Attributes Datatable
         */
        function getAttributes() {
            $.ajax({
                url: "/api/productConfiguration/attributes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            }).success(function (jsonResult, success) {
                $("#attributesTable tbody tr").remove();
                $('#loadingImgMainAttributes').hide();
                $('#attributesContent').show();

                if (jsonResult != null && jsonResult.length > 0) {
                    ProductConfigurationVM.attributes([]);
                    AttributesTableObj.clear().destroy();
                    $("#attributesTable tbody tr").remove();

                    var attributesList = $.map(jsonResult, function (result) {
                        return new ProductAttributeModel(result);
                    });

                    ProductConfigurationVM.attributes(attributesList);

                    AttributesTableObj = undefined;
                    AttributesTableObj = $('#attributesTable').DataTable({
                        "pageLength": 5,
                        "lengthChange": false,
                        "bResponsive": true,
                        'processing': true,
                        "aoColumnDefs": [{
                            "aTargets": [0],
                            "bVisible": false,
                            "bSortable": false
                        }, {
                            "aTargets": [1],
                            "bVisible": true,
                            "bSortable": true
                        }, {
                            "aTargets": [2],
                            "bVisible": true,
                            "bSortable": true
                        }, {
                            "aTargets": [3],
                            "bVisible": true,
                            "bSortable": false,
                        }, {
                            "aTargets": [4],
                            "sClass": "text-center",
                            "bVisible": true,
                            "bSortable": false,
                        }]
                    });

                    $('#attributesTable').DataTable().draw(false);
                    ProductConfigurationVM.currentAttributesPageNumber(AttributesTableObj.page());
                } else if (jsonResult.length === 0) {
                    ProductConfigurationVM.attributes([]);
                    AttributesTableObj.destroy();
                    $('#attributesTable tbody tr').remove();

                    AttributesTableObj = $('#attributesTable').DataTable({
                        "bResponsive": true,
                        "aoColumnDefs": [{
                            "atargets": [0],
                            "bvisible": false
                        }, {
                            "aTargets": [4],
                            "sClass": "text-center",
                            "bVisible": true,
                            "bSortable": false,
                        }]
                    }).draw(false);
                }

                getProducts();
            }).fail(function (error, status) {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK") {
                                navigation.unauthorized();
                            }
                        });
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAttribues() method in ProductConfiguration.js.js';
                    logger.logMessage(msg);
                }
            });
        }

        /**
          * Add/Edit an attribute
          */
        function submitAttributes(data, event) {

            var newAttribute = ko.toJS(ProductConfigurationVM.selectedAttribute());

            var attributeData = {
                Name: newAttribute.Name,
                Type: newAttribute.Type,
                Options: null,
                OptionsId: null,
                OptionsListModelObj: new OptionsListModel()
            };

            if (newAttribute.ID) {
                attributeData.ID = newAttribute.ID;
            }

            if (newAttribute.Type === 'dropdown') {
                attributeData.Options = $.map(newAttribute.Options, function (result) {
                    return result.Name;
                });
                attributeData.OptionsId = $.map(newAttribute.OptionsId, function (result) {
                    return result.Id;
                });
                attributeData.OptionsListModelObj = newAttribute.OptionsListModelObj;
            }

            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = $("input[name='__RequestVerificationToken']").val();

            try {
                if (newAttribute.Name === '') {
                    $('#valErrorRA').show();
                    $('#valErrorRA').text('Attribute Name cannot be empty!');
                    return false;
                }
                for (var index = 0; index < newAttribute.Options.length; index++) {
                    if (newAttribute.Options[index].Name === '') {
                        $('#valErrorRA').show();
                        $('#valErrorRA').text('Attribute Option cannot be empty!');
                        return false;
                    }
                }
                if (!newAttribute.ID) {
                    for (var i = 0; i < ProductConfigurationVM.attributes().length; i++) {
                        if (newAttribute.Name === ProductConfigurationVM.attributes()[i].Name() &&
                            newAttribute.Type === ProductConfigurationVM.attributes()[i].Type()) {
                            $('#valErrorRA').show();
                            $('#valErrorRA').text('Attribute with same name and type already exists!');
                            return false;
                        }
                    }
                }
                            
                $.ajax({
                    url: "/api/productConfiguration/attributes?attrModel",
                    data: attributeData,
                    type: attributeData.ID ? "PUT" : "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addAttribute() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
                function ajaxSuccess(jsonResult, success) {                 

                    getAttributes();
                    ProductConfigurationVM.selectedAttribute(new ProductAttributeModel({}));

                    $('#valErrorRA').hide();
                    $('#valErrorRA').text('');
                    if (attributeData.ID) {
                        toastr.success("Attribute has been edited successfully");
                    } else {
                        toastr.success("Attribute has been added successfully");
                    }

                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in addAttribute() method in ProductConfiguration.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in addAttribute() method in ProductConfiguration.js';
                        logger.logMessage(msg);
                    }
                }
        }

        function cancelAttributes() {
            ProductConfigurationVM.selectedAttribute(new ProductAttributeModel({}));
            getAttributes();
            $('#valErrorRA').hide();
            $('#valErrorRA').text('');
        }

        /**
         * Open delete attribute confirmation popup
         */
        function deleteAttrbuteButtonClick(data, event) {
            try {
                app.showMessage('<b>Are you sure that you want to delete this Attribute?<br/><br/><b>', 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteAttribute(data);
                            toastr.success("Attribute has been deleted successfully");
                        }
                    });

                setTimeout(function () {
                    $(event.target).focus();
                }, 1);

                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();
                return false;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: deleteProductButtonClick() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        /**
         * Delete a attribute by ID
         */
        function deleteAttribute(data) {
            try {
                $.ajax({
                    url: "/api/productConfiguration/attributes?attributeID=" + data.ID,
                    type: "DELETE",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in deleteAttribute() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    getAttributes();
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteAttribute() method in ProductConfiguration.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteAttribute() method in ProductConfiguration.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteAttribute() method in ProductConfiguration.js';
                    logger.logMessage(msg);
                }
            }
        }


        /*** Method for Products ***/


        /*
         * Open Add / Edit product Pop Up
         */
        function openProductPopup(data) {
            $('#valErrorProducts').hide();
            $('#valErrorProducts').text('');
            getAttributes();
            var attributes = ko.toJS(ProductConfigurationVM.attributes);
            ProductConfigurationVM.selectedProduct(new ProductModel({}, attributes));

            if (data) {
                ProductConfigurationVM.selectedProduct(data);
            }
        }

        /**
         * Get all products and set the DataTable
         */
        function getProducts() {
            $.ajax({
                url: "/api/productConfiguration/products",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            }).success(function (jsonResult, success) {
                $("#productsTable tbody tr").remove();
                $('#loadingImgMainProducts').hide();

                $('#productsContent').show();

                var attributes = ko.toJS(ProductConfigurationVM.attributes);

                if (jsonResult != null && jsonResult.length > 0) {
                    ProductConfigurationVM.products([]);
                    ProductsTableObj.clear().destroy();
                    $("#productsTable tbody tr").remove();

                    var productList = $.map(jsonResult, function (result) {
                        return new ProductModel(result, attributes);
                    });

                    ProductConfigurationVM.products(productList);

                    ProductsTableObj = undefined;
                    ProductsTableObj = $('#productsTable').DataTable({
                        "bResponsive": true,
                        "aoColumnDefs": [{
                            "aTargets": [0],
                            "bVisible": false,
                            "bSortable": false
                        }, {
                            "aTargets": [1],
                            "bVisible": true,
                            "bSortable": true
                        }, {
                            "aTargets": [2],
                            "bVisible": true,
                            "bSortable": true
                        }, {
                            "aTargets": [3],
                            "sClass": "text-center",
                            "bVisible": true,
                            "bSortable": false,
                        }, {
                            "aTargets": [4],
                            "bVisible": true,
                            "bSortable": true,
                        }, {
                            "aTargets": [5],
                            "bVisible": true,
                            "bSortable": true,
                        }, {
                            "aTargets": [6],
                            "sClass": "text-center",
                            "bVisible": true,
                            "bSortable": false,
                        }]
                    });

                    $('#productsTable').DataTable().draw(false);
                    ProductConfigurationVM.currentPageNumber(ProductsTableObj.page());

                    var rows = $("#productsTable").dataTable().fnGetNodes();
                    for (var i = 0; i < rows.length; i++) {
                        if ($(rows[i]).find("td:eq(2)").text().toUpperCase() == 'UNASSIGNED') {
                            if ($(rows[i]).find("td:eq(2)") != null && $(rows[i]).find("td:eq(2)") != undefined) {
                                $(rows[i]).find("td:eq(2)").css('color', '#FF0000');
                            }
                        }

                        var RespText = $(rows[i]).find("td:eq(2)").html()
                        var RespTextEdit = RespText.replace('|', '<br/>');
                        $(rows[i]).find("td:eq(2)").html(RespTextEdit);
                    }
                } else if (jsonResult.length === 0) {
                    ProductConfigurationVM.products([]);
                    ProductsTableObj.destroy();
                    $('#productsTable tbody tr').remove();

                    ProductsTableObj = $('#productsTable').DataTable({
                        "bResponsive": true,
                        "aoColumnDefs": [{
                            "atargets": [0],
                            "bvisible": false
                        }, {
                            "aTargets": [3],
                            "sClass": "text-center",
                            "bVisible": true,
                            "bSortable": false,
                        }, {
                            "aTargets": [6],
                            "sClass": "text-center",
                            "bVisible": true,
                            "bSortable": false,
                        }]
                    }).draw(false);

                }
            }).fail(function (error, status) {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK") {
                                navigation.unauthorized();
                            }
                        });
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetProducts() method in ProductConfiguration.js.js';
                    logger.logMessage(msg);
                }
            });
        }



        function addProduct() {
            var newProduct = ko.toJS(ProductConfigurationVM.selectedProduct());
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = $("input[name='__RequestVerificationToken']").val();

            try {
                if (newProduct.Name === '') {
                    $('#valErrorProducts').show();
                    $('#valErrorProducts').text('Product Name cannot be empty!');
                    return false;
                }
                if (newProduct.Description === '') {
                    $('#valErrorProducts').show();
                    $('#valErrorProducts').text('Product Description cannot be empty!');
                    return false;
                }
                $.ajax({
                    url: "/api/productConfiguration/products",
                    data: newProduct,
                    type: newProduct.ID ? "PUT" : "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addProduct() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, success) {
                try {
                    if (newProduct.ID != null) {
                        logger.logSuccess('Product details have been edited successfully', 'Success', system.getModuleId(ProductConfigurationVM), true);
                    }
                    else {
                        logger.logSuccess('Product has been added successfully.', 'Success', system.getModuleId(ProductConfigurationVM), true);
                    }
                    var attributes = ko.toJS(ProductConfigurationVM.attributes);
                    getProducts();
                    ProductConfigurationVM.selectedProduct(new ProductModel({}, attributes));
                    $('#addProductModal').modal('toggle');
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in addProduct() method in ProductConfiguration.js';
                    logger.logMessage(msg);
                }

            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteProduct() method in ProductConfiguration.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in addProduct() method in ProductConfiguration.js';
                    logger.logMessage(msg);
                }
            }
        }

        /**
         * Open delete confirmation popup
         */
        function deleteProductButtonClick(data, event) {
            try {
                app.showMessage('<b>Are you sure you want to delete this Product?<br/><br/><b>', 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteProduct(data);
                            toastr.success("Product has been deleted successfully");
                        }
                    });

                setTimeout(function () {
                    $(event.target).focus();
                }, 1);

                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();
                return false;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: deleteProductButtonClick() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function deleteProductButtonClickBulk(data, event) {
            try {
                ProductConfigurationVM.SelectedProductList([]);
                for (var i = 0; i < ProductConfigurationVM.products().length; i++) {
                    if (ProductConfigurationVM.products()[i].IsChecked()) {
                        ProductConfigurationVM.SelectedProductList().push(ProductConfigurationVM.products()[i].ID);
                    }
                }
                ProductConfigurationVM.isBulk(true);

                if (ProductConfigurationVM.SelectedProductList().length == 0) {
                    app.showMessage("None of the Products have been selected to perform the group actions", "Delete operation", ["Close"]);

                } else {
                    app.showMessage('<b>Are you sure you want to delete selected Products?<br/><br/><b>', 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                        .then(function (option) {
                            if (option === 'Confirm') {
                                deleteProduct(data);
                                toastr.success("Products have been deleted successfully");
                            }
                        });

                    setTimeout(function () {
                        $(event.target).focus();
                    }, 1);

                    event.preventDefault();
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    return false;
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: deleteProductButtonClick() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }
        /**
         * Delete a product by ID
         */
        function deleteProduct(data) {
            if (ProductConfigurationVM.isBulk() === true) {
                var productID = ProductConfigurationVM.SelectedProductList().join(',');
            } else {
                var productID = data.ID;
            }
            try {
                $.ajax({
                    url: "/api/productConfiguration/products?productID=" + productID,
                    type: "DELETE",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in deleteProduct() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    getProducts();
                    ProductConfigurationVM.isBulk(false);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteProduct() method in ProductConfiguration.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteProduct() method in ProductConfiguration.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteProduct() method in ProductConfiguration.js';
                    logger.logMessage(msg);
                }
            }
        }


        // Models 
        function ProductModel(product, attributes) {
            try {
                var self = this;
                self.ID = product.ID || null;
                self.AssignedUsers = ko.observable(product.AssignedUsers || '');
                self.Description = ko.observable(product.Description || '');
                self.LaunchStatus = ko.observable(product.LaunchStatus || '');
                self.Name = ko.observable(product.Name || '');
                self.Status = ko.observable(product.Status || 'Not Started');
                self.Type = ko.observable(product.Type || '');
                self.IsChecked = ko.observable(false);

                if (product.LaunchStatus === "Launched") {
                    self.MainListColourCode = ko.observable("#012169");
                }
                else {
                    self.MainListColourCode = ko.observable("#97999B");
                }

                // Map all attributes to the existing ones in the current product
                var presentAttributes = product.AttributeValues || [];
                var mappedAttributes = [];
                if (attributes && attributes.length > 0) {
                    $.each(attributes, function (key, attribute) {
                        // Create new attribute for the current product
                        var newAttribute = {
                            AttributeID: attribute.ID,
                            ProductID: product.ID || null,
                            OptText: '',
                            OptId: ''
                        };

                        // Set product value from the database if attribute is present
                        for (var index = 0; index < presentAttributes.length; index++) {
                            var currentAttribute = presentAttributes[index];
                            if (currentAttribute.AttributeID == attribute.ID) {
                                newAttribute.OptText = currentAttribute.OptText;
                                newAttribute.OptId = currentAttribute.OptId;
                                break;
                            }
                        }

                        mappedAttributes.push(newAttribute);
                    });
                }
                self.AttributeValues = ko.observableArray(mappedAttributes);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ProductModel() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function ProductAttributeModel(attribute) {
            try {

                var self = this;
                self.ID = attribute.ID || null;
                self.Name = ko.observable(attribute.Name || '');
                self.Type = ko.observable(attribute.Type || 'text');

                var parsedOptions = null;
                if (attribute.Options && attribute.Options.length > 0) {
                    parsedOptions = $.map(attribute.Options, function (result) {
                        return { Name: result };
                    });
                }
                self.Options = ko.observableArray(parsedOptions);

                var parsedOptionsId = null;
                if (attribute.OptionsId && attribute.OptionsId.length > 0) {
                    parsedOptionsId = $.map(attribute.OptionsId, function (result) {
                        return { Id: result };
                    });
                }
                self.OptionsId = ko.observableArray(parsedOptionsId);


                var MappedList = null;
                if (attribute.OptionsListModelObj && attribute.OptionsListModelObj.length > 0) {
                    MappedList = $.map(attribute.OptionsListModelObj, function (result) {
                        return new OptionsListModel(result);
                    });
                }
                self.OptionsListModelObj = ko.observableArray(MappedList);


                self.addNewOption = function () {
                    self.OptionsListModelObj.push(new OptionsListModel({}));
                };

                self.removeOption = function (optionValue) {
                    self.OptionsListModelObj.remove(optionValue);
                };
        }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ProductAttributeModel() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function OptionsListModel(result) {
            try {
                var self = this;
                self.OptText = ko.observable(result.OptText);
                self.OptId = ko.observable(result.OptId);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OptionsListModel() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function RespondentListModel(item) {
            try {
                var self = this;
                if (item.UserName.length > 0)
                    self.UserName = ko.observable(item.UserName);
                else
                    self.UserName = ko.observable(item.UserName());
                if (item.Role.length > 0)
                    self.Role = ko.observable(item.Role);
                else
                    self.Role = ko.observable(item.Role());
                if (!isNaN(item.UserId))
                    self.UserId = ko.observable(item.UserId);
                else
                    self.UserId = ko.observable(item.UserId());
                if (item.RoleType.length > 0)
                    self.RoleType = ko.observable(item.RoleType);
                else
                    self.RoleType = ko.observable(item.RoleType());
                if (typeof (item.IsChecked) === "boolean")
                    self.IsChecked = ko.observable(item.IsChecked);
                else
                    self.IsChecked = ko.observable(item.IsChecked());
                if (!isNaN(item.RoleId))
                    self.RoleId = ko.observable(item.RoleId);
                else
                    self.RoleId = ko.observable(item.RoleId());

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RespondentListModel() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function LaunchProductModel(item) {
            try {
                var self = this;
                self.ID = item.ID;
                //self.Name = ko.observable(item.Name);
                self.Name = $('<div/>').html(item.Name()).text();
                self.LaunchStatus = ko.observable(item.LaunchStatus);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LauncProductModel() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

    });
